import { render, staticRenderFns } from "./AppChart.vue?vue&type=template&id=2acbd9a8&scoped=true&"
import script from "./AppChart.vue?vue&type=script&lang=ts&"
export * from "./AppChart.vue?vue&type=script&lang=ts&"
import style0 from "./AppChart.vue?vue&type=style&index=0&id=2acbd9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbd9a8",
  null
  
)

export default component.exports